import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { FileText, Table, CheckSquare, Calendar } from 'lucide-react';
export function ProductDetailsSection() {
  return <>
      <Section background="white" data-id="element-82">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-83">
          <div data-id="element-84">
            <h2 className="text-3xl md:text-4xl text-[#2D3B2D] mb-8" data-id="element-85">
              Qué incluye exactamente
            </h2>
            <div className="space-y-8" data-id="element-86">
              <div className="flex gap-4" data-id="element-87">
                <div className="bg-[#FDF8F0] p-3 rounded-lg h-fit" data-id="element-88">
                  <FileText className="text-[#C4A962]" size={24} data-id="element-89" />
                </div>
                <div data-id="element-90">
                  <h3 className="font-bold text-[#2D3B2D] text-lg mb-1" data-id="element-91">
                    PDF Plan Antipánico de Deudas (30 días)
                  </h3>
                  <p className="text-[#4A5D4A]" data-id="element-92">
                    Lectura fácil, cero jerga. Tu guía paso a paso.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-93">
                <div className="bg-[#FDF8F0] p-3 rounded-lg h-fit" data-id="element-94">
                  <Table className="text-[#C4A962]" size={24} data-id="element-95" />
                </div>
                <div data-id="element-96">
                  <h3 className="font-bold text-[#2D3B2D] text-lg mb-1" data-id="element-97">
                    Plantilla Google Sheets (copy-paste)
                  </h3>
                  <p className="text-[#4A5D4A]" data-id="element-98">
                    Lista de deudas + orden de ataque, detector de fugas,
                    calendario 30 días, mini fondo.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-99">
                <div className="bg-[#FDF8F0] p-3 rounded-lg h-fit" data-id="element-100">
                  <CheckSquare className="text-[#C4A962]" size={24} data-id="element-101" />
                </div>
                <div data-id="element-102">
                  <h3 className="font-bold text-[#2D3B2D] text-lg mb-1" data-id="element-103">
                    Checklists imprimibles
                  </h3>
                  <p className="text-[#4A5D4A]" data-id="element-104">
                    Semana 1–4, Lista anti-impulso (sustitución), Protocolo "mes
                    malo".
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#FDF8F0] p-8 md:p-10 rounded-3xl border border-[#E8EDE6]" data-id="element-105">
            <h3 className="text-2xl font-serif text-[#2D3B2D] mb-6" data-id="element-106">
              Cómo se ve el cambio
            </h3>
            <p className="text-[#4A5D4A] mb-6" data-id="element-107">
              No te voy a decir que "tu vida se transforma en 24 horas". Pero sí
              pasa algo muy concreto:
            </p>
            <ul className="space-y-3 mb-8" data-id="element-108">
              {['Dejas de evitar mirar', 'Dejas de improvisar', 'Empiezas a ver avance (aunque sea pequeño)', 'El ruido mental baja, porque hay un plan'].map((item, i) => <li key={i} className="flex items-center text-[#2D3B2D] font-medium" data-id="element-109">
                  <span className="w-2 h-2 bg-[#C4A962] rounded-full mr-3" data-id="element-110" />
                  {item}
                </li>)}
            </ul>
            <p className="text-sm text-[#4A5D4A] italic" data-id="element-111">
              Y cuando el ruido baja… compras menos por ansiedad.
            </p>
          </div>
        </div>
      </Section>

      <Section id="pricing" background="cream" className="text-center" data-id="element-112">
        <div className="max-w-xl mx-auto bg-white p-10 rounded-3xl shadow-xl border border-[#E8EDE6] relative overflow-hidden" data-id="element-113">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#C4A962]" data-id="element-114" />

          <h2 className="text-3xl md:text-4xl font-serif text-[#2D3B2D] mb-4" data-id="element-115">
            Plan Antipánico
          </h2>
          <div className="flex justify-center items-baseline gap-3 mb-1" data-id="element-116">
            <span className="text-2xl text-[#4A5D4A] line-through opacity-60" data-id="element-117">
              $19
            </span>
            <span className="text-5xl font-bold text-[#2D3B2D]" data-id="element-118">$6.36</span>
            <span className="text-[#4A5D4A] ml-1" data-id="element-119">USD</span>
          </div>
          <span className="inline-block px-3 py-1 mb-4 text-xs font-semibold tracking-wide uppercase bg-[#C4A962]/15 text-[#C4A962] rounded-full" data-id="element-120">
            Descuento aplicado
          </span>
          <p className="text-[#4A5D4A] mb-8 text-sm" data-id="element-121">
            Menos que una compra impulsiva "chiquita" que luego te deja culpa.
          </p>

          <Button fullWidth className="mb-4" href="https://momentumdigitalpro.com/cart/44521034743910:1" data-id="element-122">
            Sí, quiero el Plan Antipánico
          </Button>

          <p className="text-xs text-[#4A5D4A] mt-4" data-id="element-123">
            Quiero claridad. Quiero orden. Quiero un plan que se sostenga.
          </p>
        </div>
      </Section>
    </>;
}